import { gql } from '@apollo/client';
import { IPaceCalculateForMetricArgs, IPaceHistogramTerm } from '../types';

const calculatePaceForMetric = async ({
  client,
  metric,
  dateScope,
  filters,
  groupBy,
  comparisonPeriod,
}: IPaceCalculateForMetricArgs): Promise<IPaceHistogramTerm[]> => {
  const query = {
    query: gql`
      query calculatePaceForMetric(
        $metric: MetricInput!
        $dateScope: [DateRangeInput!]!
        $filters: [FilterInput]!
        $groupBy: GroupByInput
        $comparisonPeriod: ComparisonInput
      ) {
        calculatePaceForMetric(
          metric: $metric
          dateScope: $dateScope
          filters: $filters
          groupBy: $groupBy
          comparisonPeriod: $comparisonPeriod
        ) {
          name
          average
          actual
          actualDiff
          pace
          paceDiff
          goal
          histogram {
            date
            average
            actual
            actualDiff
          }
        }
      }
    `,
    variables: {
      metric,
      dateScope,
      filters,
      groupBy,
      comparisonPeriod,
    },
  };

  const response = await client.query<{
    calculatePaceForMetric: IPaceHistogramTerm[];
  }>(query);

  return response.data.calculatePaceForMetric;
};

export default calculatePaceForMetric;
